import { render } from "./PureImageGridShell.vue?vue&type=template&id=f686261e&scoped=true"
import script from "./PureImageGridShell.vue?vue&type=script&lang=js"
export * from "./PureImageGridShell.vue?vue&type=script&lang=js"

import "./PureImageGridShell.vue?vue&type=style&index=0&id=f686261e&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f686261e"]])

export default __exports__